import { defaultTheme } from '../../../theme'
import styled, { StyledProps } from 'styled-components'
import { IconCrossCircle } from '../../iconography/Icons/Icons'
import { controlStyle } from '../../selects/BasicSelect/styles'

export const customStyles = {
  control: (base, props) => {
    return {
      ...controlStyle(base, props),
      height: '40px',
      minHeight: '40px',
      borderColor: props.isFocused ? defaultTheme.color.primary600 : defaultTheme.color.onSurfaceLowEmphasys,
      borderRadius: 0,
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
      zIndex: 1,
      cursor: 'pointer',
      boxShadow: 'none',
      transition: '0.3s border-color',
    }
  },
  menu: base => ({
    ...base,
    zIndex: 2,
  }),
}

export const Wrapper = styled.div`
  height: 40px;
  display: inline-grid;
  flex-wrap: nowrap;
  grid-template-columns: 150px auto;
  align-items: center;
  width: 450px;
  position: relative;
`

export const ClearIcon = styled(IconCrossCircle)`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  opacity: 1;
  transition: 0.3s opacity, 0.3s fill;
  z-index: 3;
  cursor: pointer;

  &:hover {
    fill: ${({ theme }: ThemedProps) => theme.color.primary600};
  }
`

type ThemedProps = StyledProps<{}>
export const Input = styled.input<ThemedProps>`
  border: 1px solid ${({ theme }: ThemedProps) => theme.color.onSurfaceLowEmphasys};
  outline: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  height: 40px;
  color: ${({ theme }: ThemedProps) => theme.color.onPrimaryDark};
  flex-grow: 1;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 0 8px 0 16px;
  background-color: ${({ theme }: ThemedProps) => theme.color.primary5};
  margin-left: -1px;
  transition: 0.3s color, 0.3s border-color;
  position: relative;
  z-index: 2;
  border-left-color: transparent;
  background-clip: padding-box;

  &::placeholder {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }: ThemedProps) => theme.color.secondary200};
  }

  &:hover {
    border-color: ${({ theme }: ThemedProps) => theme.color.onPrimaryMid};
    z-index: 2;
  }

  &:focus {
    border-color: ${({ theme }: ThemedProps) => theme.color.primary600};
  }

  &:placeholder-shown ~ ${ClearIcon} {
    opacity: 0;
    pointer-events: none;
  }

  ${props => props.theme.media.mobile`
    font-size: 16px;
    &::placeholder {
      font-size: 16px;
    }
  `}
`
